import React, { Component } from "react";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

import SecurityModal from "../../pages/Components/SecurityModal/SecurityModal";
import { connect } from "react-redux";
import {
    Card,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
} from "@material-ui/core";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import { selectReport, canUpdate } from "./selectors";
import { getReport, setReport, getJobPackReports } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";

import data from "./data.json";

//import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";

import "../reports.css";
import styled from "styled-components";
const ActionButton = styled(Button)`
    @media print {
        visibility: hidden;
    }
`;
let checkedit = "";
class TrafficCount extends Component {
    constructor(props) {
        super(props);
        let path = props.location.pathname.split("/");
        checkedit = path[1];
        this.state = {
            imageModal: false,
            selectedImg: false,
            report: false,
            editing:
                path[1] === "report-view"
                    ? false
                    : path[1] === "report-view-standalone"
                    ? false
                    : true,
            title: document.title,
            reportType: path[4].replace(/-/g, "_"),
            checks: data,
        };

        if (path[2] === "reports") {
            props.getReport(
                props.match.params.uid,
                props.match.params.subject_name.replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                path[7].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderDropDown = (key, value, opts) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === ""
                            ? "N/A"
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value="N/A">N/A</MenuItem>
                    {opts.map((option) => {
                        return (
                            <MenuItem value={option} key={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            );
        } else {
            return value === "" ? "N/A " : value;
        }
    };

    render() {
        //let report = this.props.report === false ? false : this.props.report;
        let rT = this.renderText;
        let gstyle = gridStyle;
        let cstyle = cellStyle;
        let checkRowCount = 2;

        const { editing, checks, report } = this.state;
        return editing && !this.props.canUpdate ? (
            <SecurityModal
                errType={"Update"}
                errPage={"Block Vehicle Check Report"}
                history={this.props.history}
            />
        ) : (
            <Card>
                <StyledHeader>
                    <Typography variant="h5">Traffic Count Report</Typography>
                </StyledHeader>
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                            document.title =
                                "Traffic Count Report - " +
                                this.props.match.params.report_id
                                    .replace(/_/g, " ")
                                    .replace(/\./g, ":");
                        }}
                        onAfterPrint={() => {
                            document.title = this.state.title;
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px",
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && <this.props.header />}
                            <div
                                className="imgDiv"
                                style={{
                                    float: "left",
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography variant="h5">
                                    Traffic Count Report
                                </Typography>
                            </div>
                            <div style={{ width: "100%" }}>
                                <div style={gstyle(10, 13, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 13, false, true)}
                                    >
                                        <b>Report Details</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 7)}>
                                        <b>Document Ref:</b>
                                    </div>
                                    <div style={cstyle(2, 4, 2, 7, true)}>
                                        TM-002 Rev 1
                                    </div>
                                    <div style={cstyle(2, 7, 2, 13)}>
                                        <b>Timestamp</b>
                                    </div>
                                    <div style={cstyle(2, 10, 2, 13, true)}>
                                        {report.timestamp}
                                    </div>
                                    <div style={cstyle(3, 1, 3, 7)}>
                                        <b>Date:</b>
                                    </div>
                                    <div style={cstyle(3, 4, 3, 7, true)}>
                                        {report.date}
                                    </div>
                                    <div style={cstyle(3, 7, 3, 13)}>
                                        <b>Closure Operatives</b>
                                    </div>
                                    <div style={cstyle(3, 10, 3, 13, true)}>
                                        {rT(
                                            "closure_operatives",
                                            report.closure_operatives
                                        )}
                                    </div>
                                    <div style={cstyle(4, 1, 4, 7)}>
                                        <b>Location:</b>
                                    </div>
                                    <div style={cstyle(4, 4, 4, 7, true)}>
                                        {rT("location", report.job_location)}
                                    </div>
                                    <div style={cstyle(4, 7, 4, 13)}>
                                        <b>Supervisor:</b>
                                    </div>
                                    <div style={cstyle(4, 10, 4, 13, true)}>
                                        {rT("supervisor", report.supervisor)}
                                    </div>
                                    <div style={cstyle(5, 1, 5, 7)}>
                                        <b>Operation:</b>
                                    </div>
                                    <div style={cstyle(5, 4, 5, 7, true)}>
                                        {rT("operation", report.operation)}
                                    </div>
                                    <div style={cstyle(5, 7, 5, 13)}>
                                        <b>Block Vehicle/s:</b>
                                    </div>
                                    <div style={cstyle(5, 10, 5, 13, true)}>
                                        {rT(
                                            "block_vehicles",
                                            report.block_vehicles
                                        )}
                                    </div>
                                    <div style={cstyle(6, 1, 6, 7)}>
                                        <b>Contractor:</b>
                                    </div>
                                    <div style={cstyle(6, 4, 6, 7, true)}>
                                        {rT("contractor", report.contractor)}
                                    </div>
                                    <div style={cstyle(6, 7, 6, 13)}>
                                        <b>250m Vehicle:</b>
                                    </div>
                                    <div style={cstyle(6, 10, 6, 13, true)}>
                                        {rT(
                                            "two_fifty_m_vehicles",
                                            report.two_fifty_m_vehicles
                                        )}
                                    </div>
                                    <div style={cstyle(7, 1, 7, 7)}>
                                        <b>Client Supervisor:</b>
                                    </div>
                                    <div style={cstyle(7, 4, 7, 7, true)}>
                                        {rT(
                                            "client_supervisor",
                                            report.client_supervisor
                                        )}
                                    </div>
                                    <div style={cstyle(7, 7, 7, 13)}>
                                        <b>500m Vehicle:</b>
                                    </div>
                                    <div style={cstyle(7, 10, 7, 13, true)}>
                                        {rT(
                                            "five_hundred_m_vehicles",
                                            report.five_hundred_m_vehicles
                                        )}
                                    </div>
                                    <div style={cstyle(8, 1, 8, 7)}>
                                        <b>Garda Contact Phone Number:</b>
                                    </div>
                                    <div style={cstyle(8, 4, 8, 7, true)}>
                                        {rT(
                                            "gardai_contact",
                                            report.gardai_contact
                                        )}
                                    </div>
                                    <div style={cstyle(8, 7, 8, 13)}>
                                        <b>1km Vehicle:</b>
                                    </div>
                                    <div style={cstyle(8, 10, 8, 13, true)}>
                                        {rT(
                                            "thousand_m_vehicles",
                                            report.thousand_m_vehicles
                                        )}
                                    </div>
                                    <div style={cstyle(9, 1, 9, 7)}>
                                        <b>Weather:</b>
                                    </div>
                                    <div style={cstyle(9, 4, 9, 7, true)}>
                                        {rT(
                                            "weather_conditions",
                                            report.weather_conditions
                                        )}
                                    </div>
                                    <div style={cstyle(9, 7, 9, 13)}>
                                        <b>Other (state):</b>
                                    </div>
                                    <div style={cstyle(9, 10, 9, 13, true)}>
                                        {rT("other", report.other)}
                                    </div>
                                    <div style={cstyle(10, 1, 10, 7)}>
                                        <b>Time Closure On:</b>
                                    </div>
                                    <div style={cstyle(10, 4, 10, 7, true)}>
                                        {rT(
                                            "time_closure_on",
                                            report.time_closure_on
                                        )}
                                    </div>
                                    <div style={cstyle(10, 7, 10, 13)}>
                                        <b>Time Closure Off:</b>
                                    </div>
                                    <div style={cstyle(10, 10, 10, 13, true)}>
                                        {rT(
                                            "time_closure_off",
                                            report.time_closure_off
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "100%" }}>
                                <div style={gstyle(7, 13)}>
                                    <div
                                        style={cstyle(1, 1, 1, 7, false, true)}
                                    >
                                        <b>
                                            Traffic flow level above which the
                                            closure cannot be put into effect
                                        </b>
                                    </div>
                                    <div
                                        style={cstyle(1, 1, 1, 7, false, true)}
                                    >
                                        <b>
                                            Traffic flow level above which the
                                            closure cannot be put into
                                            effectMaximum allowable traffic flow
                                            level as per Chapter 8 Table 8.5.1
                                            for Dual 2-lane Carriageway
                                        </b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 7, true)}>
                                        {rT("tc_limits_1", report.tc_limits_1)}
                                    </div>
                                    <div
                                        style={cstyle(2, 7, 2, 9, false, true)}
                                    >
                                        LANE 1
                                    </div>
                                    <div style={cstyle(2, 9, 2, 11, true)}>
                                        1200 veh/hour
                                    </div>
                                    <div style={cstyle(2, 11, 2, 13, true)}>
                                        60 veh/3 mins
                                    </div>
                                    <div style={cstyle(3, 1, 3, 7, true)}>
                                        {rT("tc_limits_2", report.tc_limits_2)}
                                    </div>
                                    <div
                                        style={cstyle(3, 7, 3, 9, false, true)}
                                    >
                                        LANE 2
                                    </div>
                                    <div style={cstyle(3, 9, 3, 11, true)}>
                                        1200 veh/hour
                                    </div>
                                    <div style={cstyle(3, 11, 3, 13, true)}>
                                        60 veh/3 mins
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    clear: "both",
                                }}
                            >
                                <div style={gstyle(9, 13, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 13, false, true)}
                                    >
                                        <b>Vehicles per 3 minutes</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 2, false)}>
                                        <b>#</b>
                                    </div>
                                    <div style={cstyle(2, 2, 2, 4, false)}>
                                        <b>Time of Count</b>
                                    </div>
                                    <div style={cstyle(2, 4, 2, 5, false)}>
                                        <b>MP</b>
                                    </div>
                                    <div style={cstyle(2, 5, 2, 6, false)}>
                                        <b>Cars</b>
                                    </div>
                                    <div style={cstyle(2, 6, 2, 8, false)}>
                                        <b>HGVs</b>
                                    </div>
                                    <div style={cstyle(2, 8, 2, 9, false)}>
                                        <b>Total</b>
                                    </div>

                                    <div style={cstyle(2, 9, 2, 13, false)}>
                                        <b>Remarks incidents and stops</b>
                                    </div>

                                    {checks.map((f) => {
                                        checkRowCount++;

                                        return (
                                            <React.Fragment key={checkRowCount}>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        1,
                                                        checkRowCount,
                                                        2
                                                    )}
                                                >
                                                    {f.id}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        2,
                                                        checkRowCount,
                                                        4
                                                    )}
                                                >
                                                    {rT(
                                                        f.time_of_count,
                                                        report[f.time_of_count]
                                                    )}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        4,
                                                        checkRowCount,
                                                        5,
                                                        true
                                                    )}
                                                >
                                                    {rT(f.mp, report[f.mp])}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        5,
                                                        checkRowCount,
                                                        6,
                                                        true
                                                    )}
                                                >
                                                    {rT(f.cars, report[f.cars])}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        6,
                                                        checkRowCount,
                                                        8,
                                                        true
                                                    )}
                                                >
                                                    {rT(f.hgvs, report[f.hgvs])}
                                                </div>
                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        8,
                                                        checkRowCount,
                                                        9,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.total,
                                                        report[f.total]
                                                    )}
                                                </div>

                                                <div
                                                    style={cellStyle(
                                                        checkRowCount,
                                                        9,
                                                        checkRowCount,
                                                        13,
                                                        true
                                                    )}
                                                >
                                                    {rT(
                                                        f.remarks,
                                                        report[f.remarks]
                                                    )}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* {this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-edit",
                                "report-view"
                            )}
                        >
                            <div>
                                <Button
                                    style={{ marginRight: 10 }}
                                    onClick={() => {
                                        this.props.setReport(
                                            this.state.report,
                                            this.props.location.pathname,
                                            reportType
                                        );
                                    }}
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                                <Button color="primary" variant="contained">
                                    Cancel
                                </Button>
                            </div>
                        </Link>
                    )}
                    {!this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-view",
                                "report-edit"
                            )}
                        >
                            <Button variant="contained">Edit</Button>
                        </Link>
                    )} */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing &&
                            checkedit === "report-edit-jobpack" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit-jobpack",
                                        "report-view"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                                this.props.setActivity(
                                                    "update",
                                                    "report",
                                                    this.state.reportType
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                        </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </Link>
                            )}

                        {!this.state.editing && checkedit === "report-view" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit-jobpack"
                                )}
                            >
                                <ActionButton
                                    variant="contained"
                                    color="primary"
                                >
                                    Edit
                                </ActionButton>
                            </Link>
                        )}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing && checkedit === "report-edit" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-edit",
                                    "report-view-standalone"
                                )}
                            >
                                <div>
                                    <ActionButton
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            this.props.setReport(
                                                this.state.report,
                                                this.props.location.pathname
                                            );
                                            this.props.setActivity(
                                                "update",
                                                "report",
                                                this.state.reportType
                                            );
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Submit
                                    </ActionButton>
                                    <ActionButton
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Cancel
                                    </ActionButton>
                                </div>
                            </Link>
                        )}

                        {!this.state.editing &&
                            checkedit === "report-view-standalone" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-view-standalone",
                                        "report-edit"
                                    )}
                                >
                                    <ActionButton
                                        variant="contained"
                                        color="primary"
                                    >
                                        Edit
                                    </ActionButton>
                                </Link>
                            )}
                    </div>
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store), canUpdate: canUpdate(store) };
    },
    { getReport, setReport, setActivity, getJobPackReports }
)(TrafficCount);
